






































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import ExtensionInfoListModel from '@/models/extension/extensionInfoListModel'
import ExtensionInfoItemModel from '@/models/extension/extensionInfoItemModel'
import ExtensionInfoItemNoteModel from '@/models/extension/extensionInfoItemNoteModel'
import apiService from '../../services/apiService'
import { UrlType } from '@/constants/urlType'

@Component
export default class InfoItemList extends Vue {
  @Prop(String) readonly investigationId!: string
  @Prop(Array) readonly infos!: Array<ExtensionInfoListModel>
  @Prop(Boolean) readonly disabled!: boolean

  private selected: Array<ExtensionInfoItemModel> = []

  @Emit()
  private async noteToggled(item: ExtensionInfoItemModel): Promise<void> {
    if (!item.isChecked) {
      this.createAnswer(item)
    } else {
      this.deleteAnswer(item)
    }
  }

  private async createAnswer(item: ExtensionInfoItemModel): Promise<void> {
    await apiService.post<ExtensionInfoItemNoteModel>(
      UrlType.ExtensionInfoItemNote,
      new ExtensionInfoItemNoteModel({
        extensionInfoItemId: item.extensionInfoItemId,
        extensionInvestigationId: this.investigationId
      })
    )
  }

  private async deleteAnswer(item: ExtensionInfoItemModel): Promise<void> {
    const confirm = window.confirm(
      'Are you sure you would like to uncheck this? Any notes saved will be deleted.'
    )

    if (confirm) {
      await apiService.delete(UrlType.ExtensionInfoItemNote, item.noteId)
    }
  }

  @Emit()
  private addNote(answerId: string): string {
    return answerId
  }

  @Watch('infos', { immediate: true })
  private onCategoriesChanged() {
    for (const info of this.infos) {
      const checked = info.extensionInfoItems.filter(x => x.isChecked)
      this.selected.push(...checked)
    }
  }
}
